// extracted by mini-css-extract-plugin
module.exports = {"img":"GiftLandingPage_img__xoEQh"};